// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.promotion-detail-content {
  background-color: var(--ion-color-light);
  color: var(--ion-color-light-contrast);
  min-height: 300px;
  padding-bottom: 25px;
  text-align: start;
}
@media screen and (min-width: 751px) and (max-width: 1080px) {
  .promotion-detail-content {
    margin: 0px 2rem;
  }
}
@media screen and (min-width: 1081px) {
  .promotion-detail-content {
    margin: 0px 3rem;
  }
}
@media (orientation: landscape) {
  .promotion-detail-content {
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  }
}
@media screen and (max-width: 750px) {
  .promotion-detail-content .picture img {
    max-height: auto;
    width: 100%;
  }
}
@media screen and (min-width: 751px) and (max-width: 1080px) {
  .promotion-detail-content .picture img {
    max-height: 37.037037037vw;
    width: 100%;
  }
}
@media screen and (min-width: 1081px) {
  .promotion-detail-content .picture img {
    max-height: 21.0526315789vw;
    width: 100%;
  }
}
.promotion-detail-content .promotion-detail-description {
  min-height: 50px;
  padding: 10px 0px;
}
.promotion-detail-content .promo-detail-actions {
  width: 300px;
  margin: 0 auto;
}
.promotion-detail-content .promo-detail-actions .back-button {
  margin-left: 40px;
}
.promotion-detail-content .terms-title {
  padding: 25px 10px 0;
  color: var(--link-color);
}
.promotion-detail-content .terms-description {
  padding: 15px 10px 0;
  font-size: 12px;
}
.promotion-detail-content a {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/components/promotions/promotion-detail/promotion-detail.component.scss"],"names":[],"mappings":"AAAA;EACE,wCAAA;EACA,sCAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;AACF;AAEE;EARF;IASI,gBAAA;EACF;AACF;AAGE;EAdF;IAgBI,gBAAA;EADF;AACF;AAGE;EAnBF;IAoBI,uCAAA;IACA,yCAAA;EAAF;AACF;AAEE;EACE;IACE,gBAAA;IACA,WAAA;EAAJ;AACF;AAIE;EACE;IACE,0BAAA;IACA,WAAA;EAFJ;AACF;AAME;EACE;IACE,2BAAA;IACA,WAAA;EAJJ;AACF;AASE;EACE,gBAAA;EACA,iBAAA;AAPJ;AAUE;EACE,YAAA;EACA,cAAA;AARJ;AAUI;EACE,iBAAA;AARN;AAYE;EACE,oBAAA;EACA,wBAAA;AAVJ;AAaE;EACE,oBAAA;EACA,eAAA;AAXJ;AAcE;EACE,eAAA;AAZJ","sourcesContent":[".promotion-detail-content {\r\n  background-color: var(--ion-color-light);\r\n  color: var(--ion-color-light-contrast);\r\n  min-height: 300px;\r\n  padding-bottom: 25px;\r\n  text-align: start;\r\n\r\n  \r\n  @media screen and (min-width: 751px) and (max-width: 1080px) {\r\n    margin: 0px 2rem;\r\n\r\n    \r\n  }\r\n  \r\n  @media screen and (min-width: 1081px) {\r\n  \r\n    margin: 0px 3rem;\r\n    \r\n  }\r\n  @media (orientation: landscape) {\r\n    padding-left: env(safe-area-inset-left);\r\n    padding-right: env(safe-area-inset-right);\r\n  }\r\n\r\n  @media screen and (max-width: 750px) {\r\n    .picture img {\r\n      max-height: auto;\r\n      width: 100%;\r\n\r\n    }\r\n  }\r\n  \r\n  @media screen and (min-width: 751px) and (max-width: 1080px) {\r\n    .picture img {\r\n      max-height: calc(100vw / 2.7);\r\n      width: 100%;\r\n    \r\n    }\r\n  }\r\n  \r\n  @media screen and (min-width: 1081px) {\r\n    .picture img {\r\n      max-height: calc(100vw / 4.75);\r\n      width: 100%;\r\n    \r\n    }\r\n  }\r\n\r\n\r\n  .promotion-detail-description {\r\n    min-height: 50px;\r\n    padding: 10px 0px;\r\n  }\r\n\r\n  .promo-detail-actions {\r\n    width: 300px;\r\n    margin: 0 auto; // Ensure centering is consistent\r\n\r\n    .back-button {\r\n      margin-left: 40px;\r\n    }\r\n  }\r\n\r\n  .terms-title {\r\n    padding: 25px 10px 0;\r\n    color: var(--link-color);\r\n  }\r\n\r\n  .terms-description {\r\n    padding: 15px 10px 0;\r\n    font-size: 12px;\r\n  }\r\n\r\n  a {\r\n    cursor: pointer;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
